/* Component Dependencies */
var memberOptionTemplate = require("templates/memberOptions.hbs");
var memberOptionCheckInConfirmationTemplate = require("templates/memberOptions-checkInConfirmation.hbs");
var memberOptionJoinAndSaveReservationHeaderTemplate = require("templates/memberOptions-joinAndSaveReservationHeader.hbs");
var memberOptionJoinAndSaveReservationTemplate = require("templates/memberOptions-joinAndSaveReservation.hbs");
var AriesComponent = require("libs/aries-component");
var PubSub = require("libs/pub-sub");
var Popup = require("libs/popup");

PubSub.register(
	AriesComponent.extend({
		type: "memberOptions",
		template: {
			memberOptions: memberOptionTemplate,
			"memberOptions-checkInConfirmation": memberOptionCheckInConfirmationTemplate,
			'memberOptions-joinAndSaveReservationHeader': memberOptionJoinAndSaveReservationHeaderTemplate,
			'memberOptions-joinAndSaveReservation': memberOptionJoinAndSaveReservationTemplate
		},
		subscribe: {
			TOGGLE_MEMBER_OPTIONS: "toggleMemberOptions",
		},
		bindEvents: function () {
			var _self = this;
			if (_self.$el.hasClass("tile-member-options-check-in-confirmation")) {
				var $window = $(window);
				var earnPointsOverlay = new Popup({
					selector: ".join-now-button.mi-popover",
					sourceBlock: ".modal-content",
					alternateCloseMarkup: true,
				});
				earnPointsOverlay.register();
				if(_self.$el.data('showOverlay') && !_self.$el.data('authUser')) {
					$window.on("load", function() {
						window.impressionTrack ? window.impressionTrack("event168|evar48=MER-web-checkin-confo-bonvoy-oneclickjoin") : '';
						_self.$el.find(".join-now-button.mi-popover").trigger("click");
					});
				}
			}
			//Save my reservation popup trigger and seting click tracking variable on load for sign in link 
			//in find reserrvation details page for on click join 
			if (_self.$el.hasClass("tile-member-options-join-and-save-res")) {
				_self.$el.find(".js-join-now-res-details-text a").addClass('custom_click_track').attr('custom_click_track_value', 'Reservation Details|Sign In|internal|event168|evar48=MER-web-reservationdetails-signIn');
				var $window = $(window);
				var joinAndSaveReservation = new Popup({
					selector: ".js-create-account-btn.mi-popover, .js-join-and-save-link.mi-popover, .js-join-now-res-details-text a",
					sourceBlock: ".modal-content",
					alternateCloseMarkup: true,
				});
				joinAndSaveReservation.register();
				if(_self.$el.data('showOverlay') && !_self.$el.data('authUser') && _self.$el.hasClass("ocj-popup-enabled")) {
					$window.on("load", function() {
						_self.$el.find(".js-join-and-save-link.mi-popover").trigger("click");
					});
				}
			}
		},
		toggleMemberOptions: function _toggleMemberOptions() {
			var _self = this;
			_self.$el.hasClass("l-display-none")
				? _self.$el.removeClass("l-display-none").addClass("l-display-block")
				: _self.$el.removeClass("l-display-block").addClass("l-display-none");
		},
	})
);
